interface SectionHeaderProps {
  title: string;
  onViewAll?: () => void;
}

export function SectionHeader({ title, onViewAll }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <h2 className="font-lexend text-[20px] font-normal leading-none tracking-[-0.25px] capitalize text-black">
        {title}
      </h2>
      {onViewAll && (
        <button
          onClick={onViewAll}
          className="font-lexend text-[0.875rem] text-[#16783A] md:text-[1rem] font-normal tracking-[-0.16px] capitalize hover:text-[#16783A]/80 transition-colors cursor-pointer"
        >
          View All
        </button>
      )}
    </div>
  );
}
